module.exports = __webpack_public_path__ + "img/103.82c98dfc.png";